import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import "core-js/modules/es.array.sort.js";
import "core-js/modules/esnext.global-this.js";
import * as e from "react";
import t from "react";
import r from "prop-types";
import n from "invariant";
function o() {
  return o = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o.apply(this, arguments);
}
function a(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = {},
    a = Object.keys(e);
  for (n = 0; n < a.length; n++) t.indexOf(r = a[n]) >= 0 || (o[r] = e[r]);
  return o;
}
var s = function s(e) {
    var _e$location = e.location,
      t = _e$location.search,
      r = _e$location.hash,
      n = _e$location.href,
      o = _e$location.origin,
      a = _e$location.protocol,
      s = _e$location.host,
      i = _e$location.hostname,
      c = _e$location.port;
    var l = e.location.pathname;
    return !l && n && u && (l = new URL(n).pathname), {
      pathname: encodeURI(decodeURI(l)),
      search: t,
      hash: r,
      href: n,
      origin: o,
      protocol: a,
      host: s,
      hostname: i,
      port: c,
      state: e.history.state,
      key: e.history.state && e.history.state.key || "initial"
    };
  },
  i = function i(e, t) {
    var r = [],
      n = s(e),
      a = !1,
      i = function i() {};
    return {
      get location() {
        return n;
      },
      get transitioning() {
        return a;
      },
      _onTransitionComplete: function _onTransitionComplete() {
        a = !1, i();
      },
      listen: function listen(t) {
        r.push(t);
        var o = function o() {
          n = s(e), t({
            location: n,
            action: "POP"
          });
        };
        return e.addEventListener("popstate", o), function () {
          e.removeEventListener("popstate", o), r = r.filter(function (e) {
            return e !== t;
          });
        };
      },
      navigate: function navigate(t) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          c = _ref.state,
          _ref$replace = _ref.replace,
          u = _ref$replace === void 0 ? !1 : _ref$replace;
        if ("number" == typeof t) e.history.go(t);else {
          c = o({}, c, {
            key: Date.now() + ""
          });
          try {
            a || u ? e.history.replaceState(c, null, t) : e.history.pushState(c, null, t);
          } catch (r) {
            e.location[u ? "replace" : "assign"](t);
          }
        }
        n = s(e), a = !0;
        var l = new Promise(function (e) {
          return i = e;
        });
        return r.forEach(function (e) {
          return e({
            location: n,
            action: "PUSH"
          });
        }), l;
      }
    };
  },
  c = function c() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var t = e.indexOf("?"),
      r = {
        pathname: t > -1 ? e.substr(0, t) : e,
        search: t > -1 ? e.substr(t) : ""
      };
    var n = 0;
    var o = [r],
      a = [null];
    return {
      get location() {
        return o[n];
      },
      addEventListener: function addEventListener(e, t) {},
      removeEventListener: function removeEventListener(e, t) {},
      history: {
        get entries() {
          return o;
        },
        get index() {
          return n;
        },
        get state() {
          return a[n];
        },
        pushState: function pushState(e, t, r) {
          var _r$split = r.split("?"),
            _r$split2 = _slicedToArray(_r$split, 2),
            s = _r$split2[0],
            _r$split2$ = _r$split2[1],
            i = _r$split2$ === void 0 ? "" : _r$split2$;
          n++, o.push({
            pathname: s,
            search: i.length ? "?".concat(i) : i
          }), a.push(e);
        },
        replaceState: function replaceState(e, t, r) {
          var _r$split3 = r.split("?"),
            _r$split4 = _slicedToArray(_r$split3, 2),
            s = _r$split4[0],
            _r$split4$ = _r$split4[1],
            i = _r$split4$ === void 0 ? "" : _r$split4$;
          o[n] = {
            pathname: s,
            search: i
          }, a[n] = e;
        },
        go: function go(e) {
          var t = n + e;
          t < 0 || t > a.length - 1 || (n = t);
        }
      }
    };
  },
  u = !("undefined" == typeof window || !window.document || !window.document.createElement),
  l = i(u ? window : c()),
  p = l.navigate;
function h(e, r) {
  return t.createServerContext ? function (e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return globalThis.__SERVER_CONTEXT || (globalThis.__SERVER_CONTEXT = {}), globalThis.__SERVER_CONTEXT[e] || (globalThis.__SERVER_CONTEXT[e] = t.createServerContext(e, r)), globalThis.__SERVER_CONTEXT[e];
  }(e, r) : t.createContext(r);
}
var m = h("Base", {
    baseuri: "/",
    basepath: "/"
  }),
  d = h("Location"),
  f = function f() {
    return e.useContext(m);
  },
  y = function y() {
    return e.useContext(d);
  };
function E(e) {
  this.uri = e;
}
var g = function g(e) {
    return e instanceof E;
  },
  v = function v(e) {
    throw new E(e);
  };
function b(t) {
  var r = t.to,
    _t$replace = t.replace,
    n = _t$replace === void 0 ? !0 : _t$replace,
    o = t.state,
    a = t.noThrow,
    s = t.baseuri;
  e.useEffect(function () {
    Promise.resolve().then(function () {
      var e = k(r, s);
      p(P(e, t), {
        replace: n,
        state: o
      });
    });
  }, []);
  var i = k(r, s);
  return a || v(P(i, t)), null;
}
var R = function R(t) {
  var r = y(),
    _f = f(),
    n = _f.baseuri; /*#__PURE__*/
  return e.createElement(b, o({}, r, {
    baseuri: n
  }, t));
};
R.propTypes = {
  from: r.string,
  to: r.string.isRequired
};
var C = function C(e, t) {
    return e.substr(0, t.length) === t;
  },
  w = function w(e, t) {
    var r, o;
    var _t$split = t.split("?"),
      _t$split2 = _slicedToArray(_t$split, 1),
      a = _t$split2[0],
      s = N(a),
      i = "" === s[0],
      c = j(e);
    for (var _e = 0, _a = c.length; _e < _a; _e++) {
      var _a2 = !1;
      var _u = c[_e].route;
      if (_u.default) {
        o = {
          route: _u,
          params: {},
          uri: t
        };
        continue;
      }
      var _l = N(_u.path),
        _p = {},
        _h = Math.max(s.length, _l.length);
      var _m = 0;
      for (; _m < _h; _m++) {
        var _e2 = _l[_m],
          _t = s[_m];
        if ($(_e2)) {
          _p[_e2.slice(1) || "*"] = s.slice(_m).map(decodeURIComponent).join("/");
          break;
        }
        if (void 0 === _t) {
          _a2 = !0;
          break;
        }
        var _r = O.exec(_e2);
        if (_r && !i) {
          var _e3 = -1 === U.indexOf(_r[1]);
          n(_e3, "<Router> dynamic segment \"".concat(_r[1], "\" is a reserved name. Please use a different name in path \"").concat(_u.path, "\"."));
          var _o = decodeURIComponent(_t);
          _p[_r[1]] = _o;
        } else if (_e2 !== _t) {
          _a2 = !0;
          break;
        }
      }
      if (!_a2) {
        r = {
          route: _u,
          params: _p,
          uri: "/" + s.slice(0, _m).join("/")
        };
        break;
      }
    }
    return r || o || null;
  },
  x = function x(e, t) {
    return w([{
      path: e
    }], t);
  },
  k = function k(e, t) {
    if (C(e, "/")) return e;
    var _e$split = e.split("?"),
      _e$split2 = _slicedToArray(_e$split, 2),
      r = _e$split2[0],
      n = _e$split2[1],
      _t$split3 = t.split("?"),
      _t$split4 = _slicedToArray(_t$split3, 1),
      o = _t$split4[0],
      a = N(r),
      s = N(o);
    if ("" === a[0]) return L(o, n);
    if (!C(a[0], ".")) {
      var _e4 = s.concat(a).join("/");
      return L(("/" === o ? "" : "/") + _e4, n);
    }
    var i = s.concat(a),
      c = [];
    for (var _e5 = 0, _t2 = i.length; _e5 < _t2; _e5++) {
      var _t3 = i[_e5];
      ".." === _t3 ? c.pop() : "." !== _t3 && c.push(_t3);
    }
    return L("/" + c.join("/"), n);
  },
  P = function P(e, t) {
    var _e$split3 = e.split("?"),
      _e$split4 = _slicedToArray(_e$split3, 2),
      r = _e$split4[0],
      _e$split4$ = _e$split4[1],
      n = _e$split4$ === void 0 ? "" : _e$split4$;
    var o = "/" + N(r).map(function (e) {
      var r = O.exec(e);
      return r ? t[r[1]] : e;
    }).join("/");
    var _t$location = t.location,
      _t$location2 = _t$location === void 0 ? {} : _t$location,
      _t$location2$search = _t$location2.search,
      a = _t$location2$search === void 0 ? "" : _t$location2$search,
      s = a.split("?")[1] || "";
    return o = L(o, n, s), o;
  },
  T = function T(e, t) {
    var r = function r(e) {
      return _(e);
    };
    return N(e).filter(r).sort().join("/") === N(t).filter(r).sort().join("/");
  },
  O = /^:(.+)/,
  _ = function _(e) {
    return O.test(e);
  },
  $ = function $(e) {
    return e && "*" === e[0];
  },
  S = function S(e, t) {
    return {
      route: e,
      score: e.default ? 0 : N(e.path).reduce(function (e, t) {
        return e += 4, function (e) {
          return "" === e;
        }(t) ? e += 1 : _(t) ? e += 2 : $(t) ? e -= 5 : e += 3, e;
      }, 0),
      index: t
    };
  },
  j = function j(e) {
    return e.map(S).sort(function (e, t) {
      return e.score < t.score ? 1 : e.score > t.score ? -1 : e.index - t.index;
    });
  },
  N = function N(e) {
    return e.replace(/(^\/+|\/+$)/g, "").split("/");
  },
  L = function L(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    return e + ((t = t.filter(function (e) {
      return e && e.length > 0;
    })) && t.length > 0 ? "?".concat(t.join("&")) : "");
  },
  U = ["uri", "path"],
  D = function D(e, t) {
    var r = Object.keys(e);
    return r.length === Object.keys(t).length && r.every(function (r) {
      return t.hasOwnProperty(r) && e[r] === t[r];
    });
  },
  M = function M(e) {
    return e.replace(/(^\/+|\/+$)/g, "");
  },
  _I = function I(t) {
    return function (r) {
      if (!r) return null;
      if (r.type === e.Fragment && r.props.children) return e.Children.map(r.props.children, _I(t));
      if (n(r.props.path || r.props.default || r.type === R, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `".concat(r.type, "`")), n(!!(r.type !== R || r.props.from && r.props.to), "<Redirect from=\"".concat(r.props.from, "\" to=\"").concat(r.props.to, "\"/> requires both \"from\" and \"to\" props when inside a <Router>.")), n(!(r.type === R && !T(r.props.from, r.props.to)), "<Redirect from=\"".concat(r.props.from, " to=\"").concat(r.props.to, "\"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.")), r.props.default) return {
        value: r,
        default: !0
      };
      var o = r.type === R ? r.props.from : r.props.path,
        a = "/" === o ? t : "".concat(M(t), "/").concat(M(o));
      return {
        value: r,
        default: r.props.default,
        path: r.props.children ? "".concat(M(a), "/*") : a
      };
    };
  },
  V = ["innerRef"],
  q = ["to", "state", "replace", "getProps"],
  X = ["key"];
var B = e.forwardRef;
void 0 === B && (B = function B(e) {
  return e;
});
var K = function K() {},
  A = B(function (t, r) {
    var n = t.innerRef,
      s = a(t, V);
    var _f2 = f(),
      i = _f2.baseuri,
      _y = y(),
      c = _y.location,
      u = s.to,
      l = s.state,
      h = s.replace,
      _s$getProps = s.getProps,
      m = _s$getProps === void 0 ? K : _s$getProps,
      d = a(s, q),
      E = k(u, i),
      g = encodeURI(E),
      v = c.pathname === g,
      b = C(c.pathname, g); /*#__PURE__*/
    return e.createElement("a", o({
      ref: r || n,
      "aria-current": v ? "page" : void 0
    }, d, m({
      isCurrent: v,
      isPartiallyCurrent: b,
      href: E,
      location: c
    }), {
      href: E,
      onClick: function onClick(e) {
        if (d.onClick && d.onClick(e), function (e) {
          return !e.defaultPrevented && 0 === e.button && !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
        }(e)) {
          e.preventDefault();
          var _t4 = h;
          if ("boolean" != typeof h && v) {
            var _e6 = a(o({}, c.state), X);
            _t4 = D(o({}, l), _e6);
          }
          p(E, {
            state: l,
            replace: _t4
          });
        }
      }
    }));
  });
A.displayName = "Link", A.propTypes = {
  to: r.string.isRequired
};
var F = /*#__PURE__*/function (_e$Component) {
  function F() {
    var _this;
    _classCallCheck(this, F);
    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }
    _this = _callSuper(this, F, [].concat(e)), _this.displayName = "ReactUseErrorBoundary";
    return _this;
  }
  _inherits(F, _e$Component);
  return _createClass(F, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      var _this$props;
      this.setState({}), (_this$props = this.props).onError.apply(_this$props, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(e.Component);
var W = e.createContext({
  componentDidCatch: {
    current: void 0
  },
  error: void 0,
  setError: function setError() {
    return !1;
  }
});
function H(_ref2) {
  var t = _ref2.children;
  var _e$useState = e.useState(),
    _e$useState2 = _slicedToArray(_e$useState, 2),
    r = _e$useState2[0],
    n = _e$useState2[1],
    o = e.useRef(),
    a = e.useMemo(function () {
      return {
        componentDidCatch: o,
        error: r,
        setError: n
      };
    }, [r]); /*#__PURE__*/
  return e.createElement(W.Provider, {
    value: a
  }, /*#__PURE__*/e.createElement(F, {
    error: r,
    onError: function onError(e, t) {
      n(e), null == o.current || o.current(e, t);
    }
  }, t));
}
H.displayName = "ReactUseErrorBoundaryContext";
var z = function (t) {
    var r, n;
    function a(r) {
      /*#__PURE__*/return e.createElement(H, null, /*#__PURE__*/e.createElement(t, o({
        key: "WrappedComponent"
      }, r)));
    }
    return a.displayName = "WithErrorBoundary(".concat(null != (r = null != (n = t.displayName) ? n : t.name) ? r : "Component", ")"), a;
  }(function (_ref3) {
    var _ref3$history = _ref3.history,
      t = _ref3$history === void 0 ? l : _ref3$history,
      r = _ref3.children;
    var n = t.location,
      _e$useState3 = e.useState({
        location: n
      }),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      o = _e$useState4[0],
      a = _e$useState4[1],
      _ref4 = function (t) {
        var r = e.useContext(W);
        r.componentDidCatch.current = void 0;
        var n = e.useCallback(function () {
          r.setError(void 0);
        }, []);
        return [r.error, n];
      }(),
      _ref5 = _slicedToArray(_ref4, 1),
      s = _ref5[0];
    if (e.useEffect(function () {
      t._onTransitionComplete();
    }, [o.location]), e.useEffect(function () {
      var e = !1;
      var r = t.listen(function (_ref6) {
        var t = _ref6.location;
        Promise.resolve().then(function () {
          requestAnimationFrame(function () {
            e || a({
              location: t
            });
          });
        });
      });
      return function () {
        e = !0, r();
      };
    }, []), s) {
      if (!g(s)) throw s;
      p(s.uri, {
        replace: !0
      });
    } /*#__PURE__*/
    return e.createElement(d.Provider, {
      value: o
    }, "function" == typeof r ? r(o) : r || null);
  }),
  G = function G(_ref7) {
    var t = _ref7.children;
    var r = y();
    return r ? t(r) : /*#__PURE__*/e.createElement(z, null, t);
  },
  J = function J(_ref8) {
    var t = _ref8.url,
      r = _ref8.children;
    var n = t.indexOf("?");
    var o,
      a = "";
    return n > -1 ? (o = t.substring(0, n), a = t.substring(n)) : o = t, /*#__PURE__*/e.createElement(d.Provider, {
      value: {
        location: {
          pathname: o,
          search: a,
          hash: ""
        }
      }
    }, r);
  },
  Q = function Q(_ref9) {
    var e = _ref9.path,
      t = _ref9.children;
    var _f3 = f(),
      r = _f3.baseuri,
      _y2 = y(),
      n = _y2.location,
      a = k(e, r),
      s = x(a, n.pathname);
    return t({
      location: n,
      match: s ? o({}, s.params, {
        uri: s.uri,
        path: e
      }) : null
    });
  },
  Y = ["uri", "location", "component"],
  Z = ["children", "style", "component", "uri", "location"],
  ee = function ee(t) {
    var r = t.uri,
      n = t.location,
      s = t.component,
      i = a(t, Y); /*#__PURE__*/
    return e.createElement(re, o({}, i, {
      component: s,
      uri: r,
      location: n
    }));
  };
var te = 0;
var re = function re(t) {
    var r = t.children,
      n = t.style,
      _t$component = t.component,
      s = _t$component === void 0 ? "div" : _t$component,
      i = t.uri,
      c = t.location,
      u = a(t, Z);
    var l = e.useRef(),
      p = e.useRef(!0),
      h = e.useRef(i),
      m = e.useRef(c.pathname),
      d = e.useRef(!1);
    e.useEffect(function () {
      return te++, f(), function () {
        te--, 0 === te && (p.current = !0);
      };
    }, []), e.useEffect(function () {
      var e = !1,
        t = !1;
      i !== h.current && (h.current = i, e = !0), c.pathname !== m.current && (m.current = c.pathname, t = !0), d.current = e || t && c.pathname === i, d.current && f();
    }, [i, c]);
    var f = e.useCallback(function () {
      var e;
      "test" !== process.env.NODE_ENV && (p.current ? p.current = !1 : (e = l.current, d.current && e && e.focus()));
    }, []); /*#__PURE__*/
    return e.createElement(s, o({
      style: o({
        outline: "none"
      }, n),
      tabIndex: "-1",
      ref: l
    }, u), r);
  },
  ne = ["location", "primary", "children", "basepath", "baseuri", "component"],
  oe = function oe(t) {
    var r = f(),
      n = y(); /*#__PURE__*/
    return e.createElement(ae, o({}, r, n, t));
  };
function ae(t) {
  var r = t.location,
    _t$primary = t.primary,
    n = _t$primary === void 0 ? !0 : _t$primary,
    s = t.children,
    i = t.basepath,
    _t$component2 = t.component,
    c = _t$component2 === void 0 ? "div" : _t$component2,
    u = a(t, ne),
    l = e.Children.toArray(s).reduce(function (e, t) {
      var r = _I(i)(t);
      return e.concat(r);
    }, []),
    p = r.pathname,
    h = w(l, p);
  if (h) {
    var _t5 = h.params,
      _a3 = h.uri,
      _s = h.route,
      _l2 = h.route.value,
      _p2 = _s.default ? i : _s.path.replace(/\*$/, ""),
      _d = o({}, _t5, {
        uri: _a3,
        location: r
      }),
      _f4 = e.cloneElement(_l2, _d, _l2.props.children ? /*#__PURE__*/e.createElement(oe, {
        location: r,
        primary: n
      }, _l2.props.children) : void 0),
      _y3 = n ? ee : c,
      _E = n ? o({
        uri: _a3,
        location: r,
        component: c
      }, u) : u; /*#__PURE__*/
    return e.createElement(m.Provider, {
      value: {
        baseuri: _a3,
        basepath: _p2
      }
    }, /*#__PURE__*/e.createElement(_y3, _E, _f4));
  }
  return null;
}
var se = function se() {
    var e = y();
    if (!e) throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    return e.location;
  },
  ie = function ie() {
    throw new Error("useNavigate is removed. Use import { navigate } from 'gatsby' instead");
  },
  ce = function ce() {
    var e = f();
    if (!e) throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var t = se(),
      r = x(e.basepath, t.pathname);
    return r ? r.params : null;
  },
  ue = function ue(e) {
    if (!e) throw new Error("useMatch(path: string) requires an argument of a string to match against");
    var t = f();
    if (!t) throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
    var r = se(),
      n = k(e, t.baseuri),
      a = x(n, r.pathname);
    return a ? o({}, a.params, {
      uri: a.uri,
      path: e
    }) : null;
  };
export { m as BaseContext, A as Link, G as Location, d as LocationContext, z as LocationProvider, Q as Match, R as Redirect, oe as Router, J as ServerLocation, i as createHistory, c as createMemorySource, l as globalHistory, P as insertParams, g as isRedirect, x as match, p as navigate, w as pick, v as redirectTo, k as resolve, D as shallowCompare, C as startsWith, f as useBaseContext, se as useLocation, y as useLocationContext, ue as useMatch, ie as useNavigate, ce as useParams, T as validateRedirect };